import { Playground } from "docz";
import React from 'react';
export default {
  Playground,
  React
};